import { baseTheme } from '@zoomit/primitives';

import { headerTheme, singleArticleTheme } from './theming-exception';

export const theme = {
  ...baseTheme,

  menu: headerTheme,
  singleArticle: singleArticleTheme,
};
